import React from 'react'
import { Route } from 'react-router'
import { links } from 'helpers'

import App from 'containers/App/App'
import CommonLayout from 'containers/CommonLayout/CommonLayout'
import ErrorContainer from 'containers/ErrorContainer/ErrorContainer'

import {
  getBusRoutes,
  getAsuddRoutes,
  getHeroesRoutes,
  // getVotingRoutes,
  getWelcomeRoutes,
  getDashboardRoutes,
  getAccessibleRoutes,
  getMarketplaceRoutes,
  getLscScheduleRoutes,
  getEmergencyAlertRoutes,
  getLscVideoDownloadRoutes,
  getLscTransportControlRoutes,
  getTransportRoutes,
  getHealthRoutes,
  getCityEconomyRoutes,
  getSensorManager,
} from './layers'


export default (
  <Route component={ErrorContainer}>
    <Route component={App}>
      <Route component={CommonLayout}>
        {getHealthRoutes(links.marketplace)}

        {getBusRoutes(links.bus)}
        {getHeroesRoutes(links.heroes)}
        {getAsuddRoutes(links.asudd)}
        {/*{getVotingRoutes(links.voting)}*/}
        {getAccessibleRoutes(links.accessible)}
        {getEmergencyAlertRoutes(links.emergencyAlert)}
        {getMarketplaceRoutes(links.marketplace)}
        {getLscScheduleRoutes(links.lscSchedules)}
        {getLscVideoDownloadRoutes(links.lscVideoDownload)}
        {getLscTransportControlRoutes(links.lscTransportControl)}
        {getDashboardRoutes(links.dashboard)}
        {getTransportRoutes(links.transport)}
        {getCityEconomyRoutes(links.cityEconomy)}
        {getSensorManager(links.sensorManager)}
      </Route>
      {getWelcomeRoutes(links.welcome)}
    </Route>
  </Route>
)
